import React from 'react';
import { Location } from '../../types';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  locations: Location[];
  selectedLocationId: string | null;
  onLocationSelect: (id: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  locations,
  selectedLocationId,
  onLocationSelect,
}) => {
  return (
    <>
      <div className={`sidebar-overlay ${isOpen ? 'show' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>Points d'intérêt</h2>
          <button className="close-button" onClick={onClose} aria-label="Fermer">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <div className="sidebar-content">
          {locations.map((location) => (
            <div
              key={location.id}
              className={`location-card ${selectedLocationId === location.id ? 'active' : ''}`}
              onClick={() => onLocationSelect(location.id)}
            >
              <h3>{location.name} {location.tracks.length > 1 && <span className="location-track-count">({location.tracks.length} éléments)</span>}</h3>
              {location.tracks.length > 0 && (
                <div className="audio-badges">
                  {location.tracks.some(t => t.seriousAudioUrl) && (
                    <span className="audio-badge serious">🎓 {location.tracks.length > 1 ? 'Sérieuses' : 'Sérieuse'}</span>
                  )}
                  {location.tracks.some(t => t.slangAudioUrl) && (
                    <span className="audio-badge discussion">💬 Discussions</span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="sidebar-footer">
          <p>📍 {locations.length} lieux à découvrir</p>
        </div>
      </aside>

      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
    </>
  );
};

export default Sidebar;
